import React from "react";
import Column from "@amzn/meridian/column";
import CycleManagementContextProvider from "./context/CycleManagementContext";
import ForceContextProvider from "./context/ForceContext";
import InductManagementDetail from "./InductManagementDetail";
import DeliveryWindowConfigContextProvider from "./context/DeliveryWindowConfigContext";
import InductProcessContextProvider from "../inductManagement/context/InductProcessContext";
import CapabilityContextProvider from "../global/context/ConfigContext";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import PermissionsContextProvider from "../permissions/PermissionsContext";

const InductManagementV2 = ({history, location}) => {
    const {spacingInset_shorthand2} = useDeviceLayout();
    return (
        <Column spacingInset={spacingInset_shorthand2} spacing={"medium"}>
            <InductProcessContextProvider>
            <CycleManagementContextProvider>
            <DeliveryWindowConfigContextProvider>
            <ForceContextProvider>
            <CapabilityContextProvider>
            <PermissionsContextProvider>
                <InductManagementDetail history={history} location={location}/>
            </PermissionsContextProvider>
            </CapabilityContextProvider>
            </ForceContextProvider>
            </DeliveryWindowConfigContextProvider>
            </CycleManagementContextProvider>
            </InductProcessContextProvider>
        </Column>
    )
}

export default InductManagementV2;


// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/InductManagementV2.js